import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Typography } from '@material-ui/core'
import qmoLogo from '../scss/img/qmo_logo.png'
import ResetPasswordCnn from '../Auth/connected/ResetPasswordCnn';

type PropsType = RouteComponentProps<any>

class ResetPasswordView extends Component<PropsType> {
    render() {
        return (
            <div>
                <div style={{ textAlign: 'center', paddingTop: '25px', paddingBottom: '0px' }}>
                    <img alt='' style={{ marginBottom: '30px', maxHeight: '200px' }} src={qmoLogo}></img>
                    <Typography variant="h2">Reset password</Typography>
                </div>
                <ResetPasswordCnn />

            </div>
        );
    }
}

export default withRouter(ResetPasswordView);